import React from 'react';
import { IconProps } from '.';

const SvgLayoutFillRounded = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill={color}
        d='M8 10.5a1 1 0 0 1 1 1v9a1 1 0 0 1-1 1H4a2 2 0 0 1-2-2v-8a1 1 0 0 1 1-1h5ZM21 10.5a1 1 0 0 1 1 1v8a2 2 0 0 1-2 2h-8a1 1 0 0 1-1-1v-9a1 1 0 0 1 1-1h9ZM20 2.5a2 2 0 0 1 2 2v3a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1v-3a2 2 0 0 1 2-2h16Z'
      />
    </svg>
  );
};

export default SvgLayoutFillRounded;
